import useCurrentUserMembership, {
  MEMBERSHIP_PENDING,
  MEMBERSHIP_UNKNOWN,
} from 'hooks/useCurrentUserMembership';

/**
 * Whether the current user holds `permission`: 'pending' | 'allowed' | 'denied'.
 *
 * Three states, not a boolean: links show only on 'allowed', and a page treats
 * 'pending' as loading rather than as a 404 it cannot take back.
 *
 * The match is the client half of v2's `can()`: exact on the string, with admin's
 * '*' the only wildcard. Duplicated rather than imported — the client and server
 * are separate bundles (see CLAUDE.md) — so the two must change together.
 */
const usePermission = (permission) => {
  const { membership, status } = useCurrentUserMembership();

  if (status === MEMBERSHIP_PENDING) return 'pending';
  // Fail closed once the lookup has given up — but never on the server, where
  // NotFoundPage would make the response a real 404 that hydration cannot undo.
  if (status === MEMBERSHIP_UNKNOWN) {
    return typeof window === 'undefined' ? 'pending' : 'denied';
  }

  const held = membership?.permissions ?? [];
  return held.includes('*') || held.includes(permission) ? 'allowed' : 'denied';
};

export default usePermission;
